import { render, staticRenderFns } from "./EditorComponentsModal.vue?vue&type=template&id=0c0ebd1c&"
import script from "./EditorComponentsModal.vue?vue&type=script&lang=js&"
export * from "./EditorComponentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports